<mat-autocomplete (optionSelected)="onAutoCompleteOptionSelect($event)">
  <mat-option *ngFor="let suggestion of (suggestions | async)" [value]="suggestion.address"> {{ suggestion.address }} </mat-option>
</mat-autocomplete>
